import React from 'react';
import viewReportIcon from '../common/static/images/view-report.png';
import { metabaseDashboards } from '../metabase-dashboard-data';
import { Box, Typography } from '@material-ui/core';
import Dashboard from './Dashboard';

import { createStyles, makeStyles } from '@material-ui/core';
import { getDashboardUrl } from './view-report';
import ViewOnlyDialog from '../common-package/ViewOnlyDialog';
import SecondaryButton from '../common-package/SecondaryButton';

const useStyles = makeStyles(() =>
  createStyles({
    button: {
      width: '100%'
    }
  })
);
interface IViewReportProps {
  open: boolean;
  onClose: () => void;
}

const ViewReport: React.FunctionComponent<IViewReportProps> = ({
  open,
  onClose
}) => {
  const [openId, setOpenId] = React.useState<number>();
  const [embedUrl, setEmbedUrl] = React.useState<string>('');
  const classes = useStyles();
  return (
    <ViewOnlyDialog
      open={open}
      onClose={onClose}
      title="View Report"
      iconUri={viewReportIcon}
      maxWidth="sm"
    >
      <Box>
        {metabaseDashboards.map(dashboard => (
          <>
            <SecondaryButton
              className={classes.button}
              fullWidth
              onClick={async () => {
                setEmbedUrl(await getDashboardUrl(dashboard.id));
                setOpenId(dashboard.id);
              }}
              text={dashboard.label}
            >
              <Typography>{dashboard.label}</Typography>
            </SecondaryButton>

            <Box mb={1} />
          </>
        ))}
      </Box>
      {openId && (
        <Dashboard
          embedUrl={embedUrl}
          onClose={() => setOpenId(undefined)}
          open={!!openId}
          label={metabaseDashboards.find(m => m.id === openId)?.label || ''}
        />
      )}
    </ViewOnlyDialog>
  );
};

export default ViewReport;
